import { TypeActivityReport } from '@f_ucs/context/report_context';

export const calculateSums = (reports: TypeActivityReport[]): { totalAddBasket: number; totalSearches: number } => {
    return reports.reduce((acc, report) => {
        acc.totalAddBasket += report.addBasket || 0;
        acc.totalSearches += report.searches || 0;
        return acc;
    }, { totalAddBasket: 0, totalSearches: 0 });
}